<template>
  <v-app v-cloak>
    <Sidebar></Sidebar>
    <Toolbar v-if="$vuetify.breakpoint.smAndDown"></Toolbar>
    <v-main :class="{'ml-0': $vuetify.breakpoint.smAndDown, 'ml-80': $vuetify.breakpoint.mdAndUp}">
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        mode="out-in"
      >
      <router-view/>
      </transition>
    </v-main>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Sidebar from './components/UI/Sidebar'
import Toolbar from './components/UI/Toolbar'
import Footer from './components/UI/Footer'

export default {
  name: 'App',
  components: {
    Sidebar,
    Toolbar,
    Footer
  },
  computed: {

  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box !important;
}
body {
  overflow-x: hidden !important;
}
$mf: 'Baloo', sans-serif;       // mf = main font
$mhf: 'Poppins', sans-serif;
$mfc: rgb(78, 81, 92);                 // ^ + color

$sf: 'Open Sans', sans-serif;   // sf = secondary font
$sfc: #808088;                 // ^ + color

$hfc: #AEBEF5;                // highlight font color

$r1: 6px;                       // round edges 1

$olc: #2f454c; // on light colors

.ml-80 {
  margin-left: 77px;
}

.subheading {
  font-family: $sf !important;
  line-height: 1.9rem;
}
body .v-application .display-3 {
  font-family: $mhf !important;
  font-size: 54px !important;
  color: $mfc;
  line-height: 1.2 !important;
}
body .v-application .display-2 {
  font-family: $mhf !important;
  color: $mfc;
  line-height: 1.1 !important;
  font-size: 37px;
}
a.primary {
  border-radius: $r1;
  font-family: $mf !important;
  font-size: 20px;
  text-transform: none !important;
  font-weight: 400;
}
a.secondary {
  border-radius: $r1;
  font-family: $mf !important;
  font-size: 20px;
  text-transform: none !important;
  font-weight: 400;
}
a.simple-btn {
  border-radius: $r1;
  font-family: $mf !important;
  font-size: 20px;
  z-index: 2;
  text-transform: none !important;
  font-weight: 400;
}
.heading-tool {
  font-family: $mf;
  font-size: 30px;
}
::-webkit-scrollbar {
    width: 8px;
}
 
/* Track */
::-webkit-scrollbar-track {
    -webkit-border-radius: 10px;
    border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    opacity:0.1;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: rgba(0,0,0,0.2); 
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
}

.v-btn--top.v-btn--absolute {
    top: 25px;
    right: 42px;
}
[v-cloak] {
  display: none
}
.theme--dark.v-list .v-list__tile--link:hover {
      background-color: transparent !important;
  }
  .v-footer .v-btn__content {
    font-family: 'Baloo', sans-serif;
    font-size: 18px;
}
.application--wrap {
    overflow-x: hidden;
}
.v-overlay--active:before {
    opacity: 0 !important;
}
@media (max-width: 600px) {
  .global-economy {
    background-position: 80% -11% !important;
    margin: -3px 0 40px 0 !important;
    width: 100% !important;
    margin-right: 0 !important;
    max-width: 100%;
    background-size: 134%;
}
}
</style>

